import { FulfillmentStage, FulfillmentColumn } from '@/types/fulfillment';

// Fulfillment stages configuration
export const fulfillmentStages: { id: FulfillmentStage; title: string }[] = [
  { id: 'discovery', title: 'Discovery' },
  { id: 'scoping', title: 'Scoping' },
  { id: 'proposal', title: 'Proposal' },
  { id: 'planning', title: 'Planning' },
  { id: 'design', title: 'Design' },
  { id: 'approval', title: 'Approval' },
  { id: 'development', title: 'Development' },
  { id: 'testing', title: 'Testing' },
  { id: 'review', title: 'Review' },
  { id: 'deployment', title: 'Deployment' },
  { id: 'training', title: 'Training' },
  { id: 'support', title: 'Support' }
];

// Generate empty columns structure
export const getEmptyColumns = (): FulfillmentColumn[] => {
  return fulfillmentStages.map(stage => ({
    id: stage.id,
    title: stage.title,
    projects: []
  }));
};
